import { api } from '@/shared/api';
import { getOrCreateDeviceId } from '@/shared/auth/deviceId';
import { getAppMode } from '@/shared/utils';
import type { AppDispatch } from '@/app/store';

/** Пуш-подписка, если она уже оформлена к моменту регистрации */
export interface PushRegistration {
  pushToken?: string;
  pushProvider?: string;
  pushTokenIsExpired?: boolean;
}

let queue: Promise<unknown> = Promise.resolve();

/**
 * Регистрация девайса. Уходит после входа, а потом ещё раз с подпиской,
 * когда человек разрешил уведомления.
 *
 * Вызовы выстраиваются в очередь — два одновременных POST /v4/devices создали
 * бы две записи на одно устройство: upsert в device-service неатомарный, а
 * уникального индекса по deviceId нет.
 */
export function registerDevice(
  dispatch: AppDispatch,
  push?: PushRegistration
): Promise<void> {
  const next = queue
    // Упавший вызов не должен рвать очередь для следующих
    .catch(() => undefined)
    .then(() =>
      dispatch(
        api.endpoints.createDevice.initiate({
          deviceId: getOrCreateDeviceId(),
          type: getAppMode() === 'max' ? 'MAX' : 'PWA',
          version: window.__CONFIG__?.version,
          ...push,
        })
      ).unwrap()
    );

  queue = next;

  return next.then(() => undefined);
}
